<template>
    <div class="flex items-center justify-between">
        <p v-if="label" v-text="label"></p>
        <div class="starRating__container">
            <div v-for="(star, index) in stars"
                 :key="index"
                 :class="getStarClass(star.variant, star.number)"
                 @click="handleStarClick(star.number)"
                 @mouseover="handleHoverEvent(star.number)"
                 @mouseleave="handleMouseLeaveEvent">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StarRatingField',
    data() {
        return {
            stars: [],
            variants: [
                'a',
                'b',
                'c',
                'd',
                'e',
            ],
            hoverValue: 0,
        };
    },
    props: {
        label: {
            type: String,
            required: false,
        },
        maxStars: {
            type: Number,
            default: 5,
        },
        value: {
            type: Number,
        },
    },
    mounted() {
        for (let i = 1; i <= this.maxStars; i++) {
            this.stars.push({ variant: this.getVariantForStarNumber(i), number: i });
        }
    },
    methods: {
        /**
         * Return the css class for the star.
         *
         * @param {string} variant
         * @param {number} starNumber
         *
         * @returns {string}
         */
        getStarClass(variant, starNumber) {
            let preClass = '';

            if (this.hoverValue) {
                preClass = starNumber <= this.hoverValue ? 'starRating__star--filled ' : preClass;
            } else {
                preClass = starNumber <= (this.value || 0) ? 'starRating__star--filled ' : '';
            }

            return `${preClass} starRating__star starRating__star-${variant.toLowerCase()}`;
        },

        /**
         * Get the letter variant based on the index of the star starting from 1.
         *
         * @returns {String}
         */
        getVariantForStarNumber(i) {
            let key = (i % 5);

            return this.variants[key];
        },

        /**
         * Handle the click event when a star is selected.
         *
         * @param number
         *
         * @returns {void}
         */
        handleStarClick(number) {
            this.$emit('input', number);
        },

        /**
         * Handle the hover even when the user hovers the cursor over a star.
         *
         * @param number
         *
         * @returns {void}
         */
        handleHoverEvent(number) {
            this.hoverValue = number;
        },

        /**
         * Handle the mouse cursor exit event.
         *
         * @returns {void}
         */
        handleMouseLeaveEvent() {
            this.hoverValue = 0;
        },
    },
};
</script>
